export default __webpack_public_path__ + "static/media/flag-sl.d8dcecf2.svg";